module.exports = __webpack_public_path__ + "static/media/am_client-requests.17857baa.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_client-requests.md
// module id = 1086
// module chunks = 0